/* Package JSON Import will be here */
import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { bindActionCreators } from 'redux';
/* Package JSON Import will be here */

/* Project Import will be here */
import DivisionComponent from './divisions.Component';
import { ApiUrls } from '../../services/api';
import Api from '../../services/api/serviceCall';
import { Constants } from '../../config/appConstants';
import { MessageBox } from '../sharedComponent/messageBox';
import * as actions from '../../actions/login.Action';
/* Project Import will be here */

/* Const,Let & Var will be here */
/* Const,Let & Var will be here */

class DivisionPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            divisionDataList: [],
            isOpenModel: false,
            pagination: {
                activePage: 1,
                totalCount: 0,
                skip: Constants.DEFAULT_SKIP,
                take: Constants.DEFAULT_TAKE
            },
            selectedValue: {},
            isEditDivision: false,
            divisionNameSearchText: "",
            statusSearchText: "",
            isSetButtonConfirm: false,
            isSetButtonDisabled: false
        };
    }

    componentDidMount() {
        this.getDivisionList();
    }

    getDivisionDetails(divisionId) {
        let { selectedValue } = this.state;
        let url = `${ApiUrls.Routes.DIVIS_C}${ApiUrls.Routes.GT_DVS_M}?divisionId=${divisionId}`;
        Api.Get(url, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    responseData.data.division.forEach((a) => {
                        selectedValue.divisionName = a.divisionName;
                        selectedValue.status = a.isActive;
                        selectedValue.divisionId = a.divisionId;
                    });
                    this.setState({
                        selectedValue, isEditDivision: true
                    });
                }
            }
        });
    }

    getDivisionList() {
        let { divisionNameSearchText, statusSearchText, pagination } = this.state;
        let searchArray = [];
        if (divisionNameSearchText) {
            let searchObj = {
                FieldName: Constants.DIVISION_NAME_SEARCH,
                Value: divisionNameSearchText
            };
            searchArray.push(searchObj);
        };
        if (statusSearchText) {
            let searchObj = {
                FieldName: Constants.DIVISION_STATUS_SEARCH,
                Value: statusSearchText
            };
            searchArray.push(searchObj);
        };
        let requestData = {
            SearchText: searchArray,
            Skip: pagination.skip,
            Take: pagination.take
        }
        let url = `${ApiUrls.Routes.DIVIS_C}${ApiUrls.Routes.GT_A_DVS_LT_M}`;
        Api.Post(url, requestData, this).then((responseData) => {
            if (responseData) {
                if (responseData.success) {
                    pagination.totalCount = Math.ceil(responseData.totalCount / Constants.DEFAULT_TAKE);
                    this.setState({
                        divisionDataList: responseData.data,
                        pagination
                    });
                }
                else {
                    this.setState({
                        divisionDataList: []
                    });
                }
            }
        });
    }

    onPageChange = (e, { activePage }) => {
        let { pagination } = this.state;
        pagination.skip = ((activePage - 1) * Constants.DEFAULT_TAKE) + 1;
        pagination.take = ((activePage - 1) * Constants.DEFAULT_TAKE) + Constants.DEFAULT_TAKE;
        pagination.activePage = activePage;
        this.setState({
            pagination
        }, () => {
            this.getDivisionList();
        });
    }

    onDivisionSearch = event => {
        this.setState({ divisionNameSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
            this.getDivisionList();
        });
    }

    //onStatusSearch = event => {
    //    this.setState({ statusSearchText: event.target.value, pagination: { skip: Constants.DEFAULT_SKIP, take: Constants.DEFAULT_TAKE, activePage: 1, totalCount: 0 } }, () => {
    //        this.getDivisionList();
    //    });
    //}

    handleDivisionNameChange = (e, { value }) => {
        let { selectedValue } = this.state;
        selectedValue.divisionName = value.trimStart().replace("_","").slice(0, Constants.DIVISION_NAME_MAX_LENGTH);
        this.setState({ selectedValue });
    }

    onOpenModel = divisionDetails => {
        if (divisionDetails.divisionId) {
            this.getDivisionDetails(divisionDetails.divisionId);
        }
        this.setState({
            isOpenModel: true
        });
    }

    onCloseModel = () => {
        this.setState({ isOpenModel: false, isEditDivision: false, selectedValue: {} }, () => this.getDivisionList());
    }

    onSaveDivision(divisionId = null, status = null) {
        let { selectedValue, isEditDivision, divisionDataList } = this.state;
        this.setState({ isSetButtonDisabled: true });
        if (!selectedValue.divisionName) {
            MessageBox(Constants.PLEASE_ENTER_DIVISION_NAME, Constants.ERROR);
            this.setState({ isSetButtonDisabled: false });
            return;
        }
        if (divisionId != null) {
            divisionDataList = divisionDataList.filter(a => a.divisionId !== divisionId);
        }
        //let checkDivisionNameAlreadyExists = divisionDataList.find(x => x.divisionName.toLowerCase() === selectedValue.divisionName.toLowerCase());
        //if (checkDivisionNameAlreadyExists !== undefined) {
        //    MessageBox(Constants.DIVISION_NAME_ALREADY_EXISTS, Constants.ERROR);
        //    this.setState({ isSetButtonDisabled: false });
        //    return;
        //}
        //let divisionDetails = [];

        if (divisionId != null) {
            selectedValue.divisionId = divisionId;
            isEditDivision = false;
        }
        if (divisionId != null && status != null) {
            selectedValue.isActive = status === true ? false : true;
        }
        else {
            selectedValue.isActive = selectedValue.status;
        }
        // selectedValue.divisionName.map((a) => {
        //     divisionDetails.push({
        //         DivisionId: a,
        //     })
        // })       
        selectedValue.UserId = this.props.user.userId;
        let url = `${ApiUrls.Routes.DIVIS_C}${ApiUrls.Routes.SV_DVS_M}`;
        Api.Post(url, selectedValue, this).then((responseData) => {
            if (responseData && divisionId == null) {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                if (!responseData.success) {
                    this.setState({ isSetButtonDisabled: false });
                }
            }
            else if (responseData && divisionId != null && responseData.success) {
                MessageBox(Constants.UPDATED_SUCCESSFULLY, Constants.SUCCESS);
            }
            else {
                MessageBox(responseData.message, responseData.success ? Constants.SUCCESS : Constants.ERROR);
                this.setState({ isSetButtonDisabled: false });
            }
            if (responseData.success) {
                this.onCloseModel();
                this.setState({ isSetButtonConfirm: false, isSetButtonDisabled: false });
            }
        });
    }

    //onClickSetButton(divisionId = null, status = null){
    //    this.setState({ isSetButtonDisabled: true});
    //    let url = `${ApiUrls.Routes.DIVIS_C}${ApiUrls.Routes.GT_USR_DVS_M}?divisionId=${divisionId}`;
    //    Api.Get(url, this).then((responseData) => {
    //        if (responseData) {
    //            if (responseData.success) {
    //                if(responseData.data.userDivision.length > 0){
    //                    this.setState({ isSetButtonConfirm: true });
    //                }
    //                else{
    //                    this.onSaveDivision(divisionId,status);
    //                }
    //            }
    //        }
    //    });
    //}

    onCancelConfirm() {
        this.setState({ isSetButtonConfirm: false })
    }

    render() {
        const { divisionDataList, isEditDivision, isSetButtonDisabled, groupAccess, Division, selectedValue, group, isOpenModel, pagination, isSetButtonConfirm } = this.state;
        return (
            <Fragment>
                <DivisionComponent
                    {...{
                        division: {
                            divisionDataList,
                            isOpenModel,
                            pagination,
                            groupAccess,
                            Division,
                            group,
                            selectedValue,
                            isEditDivision,
                            isSetButtonConfirm,
                            isSetButtonDisabled
                        }
                    }}
                    onOpenModel={this.onOpenModel.bind(this)}
                    onCloseModel={this.onCloseModel.bind(this)}
                    onSaveDivision={this.onSaveDivision.bind(this)}
                    onDivisionSearch={this.onDivisionSearch.bind(this)}
                    //onStatusSearch={this.onStatusSearch.bind(this)}
                    handleDivisionNameChange={this.handleDivisionNameChange.bind(this)}
                    onPageChange={this.onPageChange.bind(this)}
                    user={this.props.user}
                    //onClickSetButton={this.onClickSetButton.bind(this)}
                    onCancelConfirm={this.onCancelConfirm.bind(this)}
                />
            </Fragment>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.loginReducer.user
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        Object.assign({},
            actions),
        dispatch);
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DivisionPage));
DivisionPage.displayName = 'DivisionPage';